import { render, staticRenderFns } from "./timestopSettings.vue?vue&type=template&id=33e9318e"
import script from "./timestopSettings.vue?vue&type=script&lang=js"
export * from "./timestopSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports